import { render } from "./AddonDetails.vue?vue&type=template&id=94f343ae&scoped=true"
import script from "./AddonDetails.vue?vue&type=script&lang=js"
export * from "./AddonDetails.vue?vue&type=script&lang=js"

import "./AddonDetails.vue?vue&type=style&index=0&id=94f343ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f343ae"]])

export default __exports__